import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ing_industrias_ali',
  templateUrl: './ing_industrias_ali.component.html',
  styleUrls: ['./ing_industrias_ali.component.css']
})
export class Ing_industrias_aliComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
